import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdAlert } from '@commander-services/gui-components';
import usePageWithForm from '../../../../hooks/usePageWithForm';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import useAnalytics from '../../../../hooks/useAnalytics';

interface IModalFormProps {
  id: string;
  children: React.ReactNode;
  save: (values: any) => void;
  isButtonLoaderActive: boolean;
  alert: any;
  isDone: boolean;
  email: string;
  isValid: boolean;
}

export default function Form(props: IModalFormProps): JSX.Element {
  usePageWithForm();
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  useDocumentTitle(f({ id: 'forgotPassword.passwordReset' }));

  return (
    <div className="w-login-content">
      {!props.isDone && <CmdAlert id="login-alert" data={props.alert} />}
      <div className="b-login">
        <div className="headline">
          <h3 className="title">{f({ id: 'forgotPassword.passwordReset' })}</h3>
        </div>
        {!props.isDone ? (
          <form id={props.id} onSubmit={props.save}>
            <div className="p-8">{props.children}</div>
            <div className="text-right">
              <div className="foot py-6 px-8">
                {props.isButtonLoaderActive ? (
                  <div className="e-button e-button--gray d-flex w-100">
                    <i className="cmd-icon-loader animation-spin" />
                  </div>
                ) : (
                  <button
                    type="submit"
                    id="submitNewPassword"
                    onClick={(event) => {
                      trackEvent(['Forgot password', 'click', 'Submit form'])
                      props.save(event);
                    }}
                    className="e-button e-button--gray d-flex w-100"
                    data-cy="button_submit_forgot_password"
                    disabled={!props.isValid}
                  >
                    {f({ id: 'forgotPassword.send' })}
                  </button>
                )}
                <a
                  href="/"
                  onClick={() => trackEvent(['Forgot password', 'click', 'Login link'])}
                  title=""
                  className="fs-3 mt-1 d-inline-block"
                >
                  {f({ id: 'forgotPassword.login' })}
                </a>
              </div>
            </div>
          </form>
        ) : (
          <div>
            <div className="p-8">
              {f({ id: 'forgotPassword.resetDone' })} <strong>{props.email}</strong>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
